import { render, staticRenderFns } from "./oalogin.vue?vue&type=template&id=53d41027&scoped=true"
import script from "./oalogin.vue?vue&type=script&lang=js"
export * from "./oalogin.vue?vue&type=script&lang=js"
import style0 from "./oalogin.vue?vue&type=style&index=0&id=53d41027&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d41027",
  null
  
)

export default component.exports